<form #form="ngForm" class="campanha-tabela-preco-form" novalidate>
    <div class="card">
        <div class="card-header">
            <h6 class="card-title">
                Tabelas de Preços
            </h6>
            <p class="form-text text-muted">
                Tabelas de preços que podem ser utilizadas nesta campanha
            </p>

            <div class="card-header-warning" *ngIf="canEdit">
                <div class="card-header-warning-icon">
                    <i class="fas fa-exclamation-triangle"></i>
                </div>
                <div class="card-header-warning-text">
                    <span>Ao adicionar uma ou mais tabelas de preços, esta campanha poderá utilizar somente estas tabelas</span>
                    <span>Não adicione nenhuma tabela de preço para que todas possam ser utilizadas</span>
                </div>                     
            </div>
        </div> 
        <div class="table-responsive campanha-tabela-preco">
            <table class="table table-bordered">
                <thead>
                    <tr>
                        <th class="col-options" *ngIf="canEdit"></th>
                        <th class="col-tabela-preco">Tabela de Preço</th>
                    </tr>
                </thead>
                <tbody *ngFor="let entity of entities; let i = index">
                    <tr>
                        <td class="col-options" *ngIf="canEdit">
                            <a (click)="delete(i)">
                                <i class="far fa-trash-alt" aria-hidden="true"></i>
                            </a>
                        </td>
                        <td class="col-tabela-preco">
                            <div class="input-group">

                                
                                <select class="form-control" name="campanhaTabelaPreco_{{i}}" id="campanhaTabelaPreco_{{i}}"
                                    [ngModel]="entity.idTabelaPreco || ''" (ngModelChange)="onChangeTabelaPreco(entity, $event ? $event : null)"
                                    #campanhaTabelaPreco="ngModel" #campanhaTabelaPrecoSelect required="required" [disabled]="!canEdit">
                                    <option value="">NENHUMA TABELA DE PREÇO</option>
                                    <option *ngFor="let tabelaPreco of tabelasPrecos" [ngValue]="tabelaPreco.id">
                                        <ng-template [ngIf]="tabelaPreco.codigoIntegracaoErp">
                                            {{tabelaPreco.codigoIntegracaoErp}} -
                                        </ng-template>
                                        {{tabelaPreco.nome | uppercase}}
                                    </option>
                                </select>

                                <div class="input-group-append" *ngIf="isTabelaPrecoSituacaoInativa(entity)">
                                    <span class="input-group-text">
                                        <span class="badge badge-danger">Inativa</span>
                                    </span>
                                </div>                            
                            </div>
                            <sgt-form-control-error
                                *ngIf="campanhaTabelaPreco.errors && campanhaTabelaPreco.errors.required && campanhaTabelaPreco.dirty"
                                msgError="A tabela de preço é obrigatória">
                            </sgt-form-control-error>
                        </td>
                    </tr>
                </tbody>
                <tbody *ngIf="entities?.length === 0" class="no-record">
                    <tr>
                        <td class="text-center" colspan="2">
                            <i class='fas fa-info' aria-hidden='true'></i> Todas tabelas de preços disponíveis para esta campanha
                        </td>
                    </tr>
                </tbody>
                <tfoot class="table-footer" *ngIf="canEdit">
                    <tr>
                        <td colspan="2">
                            <button type="button" class="btn btn-primary btn-sm mr-2" (click)="insert()">
                                <i class="fas fa-plus" aria-hidden="true"></i> Adicionar Tabela de Preço
                            </button>
                        </td>
                    </tr>
                </tfoot>
            </table>
        </div> 
    </div>
</form>